module.exports = __webpack_public_path__ + "img/d3sj-btn.bf10f67d.png";